import React from 'react'
import tw from 'tailwind-styled-components'
import {cn} from '@containers/html-utils'

interface Props {
  children: React.ReactNode
  size?: 'big' | 'small'
  className?: string
}

const TwContent = tw.div<{$size: 'big' | 'small'}>`
  flex
  flex-col
  items-start
  gap-0
  p-24
  rounded-16
  bg-generic-white
  shadow-x1

  ${p => {
    if (p.$size === 'small') {
      return 'w-[343px] h-[352px]'
    }

    return 'w-[678px]'
  }}
`

export const ItemContainer = ({children, size = 'small', className}: Props) => {
  return (
    <TwContent className={cn('flex flex-col', className)} $size={size}>
      {children}
    </TwContent>
  )
}
